import { useMutation } from '@apollo/client/react'
import { useSearchParams } from 'react-router-dom'
import { gql } from '@apollo/client'
import Spinner from '../Spinner/Spinner'
import { VERIFY_EMAIL_MUTATION } from '../../graphql.js'
import MessageCard from '../MessageCard/MessageCard'
import { Alert } from 'reactstrap'

const VERIFY_EMAIL = gql(VERIFY_EMAIL_MUTATION)

export default function VerifyEmail() {
  console.log('VerifyEmail rendered')

  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  console.log('VerifyEmail token: ', token)
  const [verifyEmail, { loading, error, data }] = useMutation(VERIFY_EMAIL)
  
  if (!token) {
    return <Alert color="danger">Email verification error: no token</Alert>
  } else {
    if (!loading && !error && !data) {
      verifyEmail({ variables: { token: token } })
    }
  }

  if (loading) {
    return <Spinner />
  }
  if (error) {
    return <Alert color="danger">{error.message}</Alert>
  }
  if (data && data.verifyEmail) {
    return (
      <MessageCard
        title='Verify Email Address'
        message={data.verifyEmail}
        buttonText="Go To Login"
        clickUrl="/login"
      />
    )
  }
  return ''
}
